import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarEmpty } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextareaAutosize, Tooltip } from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { alert } from "../../../../common/Alert";
import { Input } from "../../../../common/inputs/Input";
import { RequiredAsterisk } from "../../../../common/RequiredAsterisk";
import { DEFAULT_TEMPLATE_EXAMPLES } from "../../../constants";
import ChooseTemplateType from "../ChooseTemplateType";

const MetadataSection = ({ handleTemplateTypeChange, control }) => {
  const { watch } = useFormContext(control);
  const formData = watch();
  return (
    <div
      id="template-details"
      className="bg-gray-50 dark:bg-gray-700/50 border border-gray-100 dark:border-gray-700 rounded-xl p-4"
    >
      <div className="relative flex items-center mb-4">
        <div className="w-full">
          <label
            htmlFor="name"
            className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-1"
          >
            Name <RequiredAsterisk />
          </label>
          <Controller
            control={control}
            name="name"
            render={({ field }) => (
              <Input
                type="text"
                id="name"
                name="name"
                data-testid="template-name-input"
                placeholder={
                  formData?.templateType === "SOAP"
                    ? DEFAULT_TEMPLATE_EXAMPLES.SOAP.name
                    : DEFAULT_TEMPLATE_EXAMPLES.CUSTOM.name
                }
                value={formData?.name}
                onChange={(e) => {
                  field.onChange(e);
                }}
                required
              />
            )}
          />
        </div>
        <div className="absolute -top-1 right-1">
          <Controller
            name="isFavourite"
            control={control}
            render={({ field }) => (
              <label className="cursor-pointer">
                <input
                  {...field}
                  type="checkbox"
                  className="sr-only"
                  checked={field.value}
                  onChange={(evt) => {
                    field.onChange(evt.target.checked);
                    alert(
                      "success",
                      `You've ${
                        evt.target.checked ? "marked" : "unmarked"
                      } this template as a favorite. ${
                        evt.target.checked
                          ? "It will now be displayed at the top of your templates list."
                          : "It will no longer be displayed at the top of your templates list."
                      }`,
                    );
                  }}
                />
                <Tooltip
                  title={`Click to ${
                    field.value ? "unmark" : "mark"
                  } this template as a favorite. ${
                    field.value
                      ? ""
                      : "If favorited, it will be displayed at the top of your templates list."
                  }`}
                  arrow
                  placement="left"
                >
                  <div>
                    <FontAwesomeIcon
                      icon={field.value ? faStar : faStarEmpty}
                      size="lg"
                      className="text-yellow-500 hover:text-yellow-600 transition"
                    />
                  </div>
                </Tooltip>
              </label>
            )}
          />
        </div>
      </div>
      {/* Description */}
      <div className="mb-4">
        <label
          htmlFor="description"
          className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-1"
        >
          Description
        </label>
        <Controller
          control={control}
          name="description"
          render={({ field }) => (
            <TextareaAutosize
              type="text"
              multiline="true"
              maxRows={2}
              id="description"
              name="description"
              placeholder={
                formData?.templateType === "SOAP"
                  ? DEFAULT_TEMPLATE_EXAMPLES.SOAP.description
                  : DEFAULT_TEMPLATE_EXAMPLES.CUSTOM.description
              }
              value={field.value}
              onChange={(e) => {
                field.onChange(e);
              }}
              className="resize-none appearance-none w-full px-3 py-2 border dark:bg-gray-700 dark:border-gray-700 dark:text-gray-200 border-gray-100 bg-gray-100 placeholder-gray-400 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-300 disabled:dark:bg-transparent disabled:bg-transparent text-sm"
            />
          )}
        />
      </div>

      <ChooseTemplateType
        handleTemplateTypeChange={handleTemplateTypeChange}
        formData={formData}
      />
    </div>
  );
};

export default MetadataSection;
